module.exports = __webpack_public_path__ + "img/1722485784406-WhatsApp Image 2024-08-01 at 12.12.52.jpeg.2f1d479c.webp";